<template>
  <BaseBlock v-if="finishNotCreation" :title="titleForm">
    <v-form v-model="valid" ref="form">
      <BaseAlert :error="error" />
      <v-row>
        <v-col v-if="typeFormulaire === 'creationCompte'" class="py-0" cols="6">
          <v-text-field
            v-model="etudiant.nom"
            label="Votre nom"
            :rules="nomRules"
            @input="resetApiErrors('nom')"
            :error-messages="checkApiErrors('nom')"
            outlined
            shaped
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="typeFormulaire === 'creationCompte'" class="py-0" cols="6">
          <v-text-field
            v-model="etudiant.prenom"
            label="Votre prénom"
            :rules="prenomRules"
            @input="resetApiErrors('prenom')"
            :error-messages="checkApiErrors('prenom')"
            outlined
            shaped
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="typeFormulaire === 'creationCompte'" class="py-0" cols="6">
          <v-text-field
            v-model="etudiant.email"
            label="Votre adresse mail"
            :rules="mailRules"
            @input="resetApiErrors('email')"
            :error-messages="checkApiErrors('email')"
            outlined
            shaped
            required
          ></v-text-field>
        </v-col>
        <v-col v-if="typeFormulaire === 'creationCompte'" class="py-0" cols="6">
          <v-text-field
            v-model="etudiant.emailConfirm"
            label="Confirmation adresse mail"
            :rules="mailConfirmRules"
            @input="resetApiErrors('emailConfirm')"
            :error-messages="checkApiErrors('emailConfirm')"
            outlined
            required
            shaped
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="6">
          <v-text-field
            v-model="etudiant.mdp"
            label="Mot de passe"
            @input="resetApiErrors('mdp')"
            :error-messages="checkApiErrors('mdp')"
            :rules="passwordRules"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            outlined
            shaped
            required
          ></v-text-field>
        </v-col>
        <v-col class="py-0" cols="6">
          <v-text-field
            v-model="etudiant.mdpConfirm"
            label="Confirmation mot de passe"
            @input="resetApiErrors('mdpConfirm')"
            :error-messages="checkApiErrors('mdpConfirm')"
            :rules="passwordConfirmRules"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            outlined
            shaped
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-center">
            <v-btn
              class="mx-2"
              :disabled="!valid"
              color="primary"
              @click="valideForm"
              :loading="loading"
            >
              <v-icon left>mdi-magnify</v-icon>Valider
            </v-btn>
            <v-btn class="mx-2" @click="$refs.form.reset()">
              <v-icon left>mdi-refresh</v-icon>Effacer
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </BaseBlock>
  <BaseBlock v-else title="Validation de la création du compte">{{
    valideFormMessage
  }}</BaseBlock>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiGestionCompte from "@/repositories/ApiGestionCompte";
import BaseForm from "@/components/base/BaseForm";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "BaseFormulaireCompte",
  props: ["typeFormulaire", "titleForm"],
  components: { BaseBlock, BaseAlert },
  extends: BaseForm,
  data() {
    return {
      etudiant: {
        nom: "",
        prenom: "",
        email: "",
        emailConfirm: "",
        mdp: "",
        mdpConfirm: "",
      },
      show1: false,
      show2: false,
      loading: false,
      finishNotCreation: true,
      valideFormMessage: "",
      pattern:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#?$%^&*=+;:.])(?=.{10,})/,
      nomRules: [(v) => !!v || "Nom doit être renseigné"],
      prenomRules: [(v) => !!v || "Prénom doit être renseigné"],
      mailRules: [
        (v) =>
          /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail doit être valide",
      ],
      mailConfirmRules: [
        (v) =>
          this.etudiant.email == v || "Les deux E-mail ne correspondent pas",
      ],
      passwordRules: [
        (v) =>
          this.pattern.test(v) ||
          "Min. 10 caractères avec au moins une majuscule, une minuscule, un chiffre et un caractère spécial !@#?$%^&*=+;.:",
      ],
      passwordConfirmRules: [
        (v) =>
          this.etudiant.mdp == v ||
          "Les deux mots de passes ne correspondent pas",
      ],
    };
  },
  async created() {
    if (this.typeFormulaire == "modificationMdp") {
      this.valideFormMessage = "Votre mot de passe a bien été modifié !";
    } else {
      this.valideFormMessage =
        "Votre compte a été créé ! Vous pouvez vous connecter.";
    }
  },
  methods: {
    async creationCompte() {
      try {
        this.loading = true;
        await ApiGestionCompte.creationCompte(this.etudiant);
        this.finishNotCreation = false;
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loading = false;
      }
    },
    async modificationMdp() {
      this.loading = true;
    },
    async valideForm() {
      if (this.typeFormulaire == "modificationMdp") {
        this.modificationMdp();
      } else {
        this.creationCompte();
      }
    },
  },
};
</script>
